<template>
  <div class="c-list--metrics">
    <div class="c-list--metrics__inner">
      <ListItemMetrics
        v-for="(value, key) in itemData"
        :key="key"
        :checked="checked"
        :gaType="gaType"
        :id="key"
        :item="items[key]"
        :itemData="itemData[key]"
        :periodLastMonth="periodLastMonth"
        :periodLastYear="periodLastYear"
        :isLoading="isLoading"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import ListItemMetrics from '@/components/ListItemMetrics';
import utils from '@/utils';

export default {
  props: {
    checked: {
      type: Array,
      required: true
    },
    gaType: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: true
    },
    itemData: {
      type: Object,
      required: true
    },
    period: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  components: {
    ListItemMetrics
  },
  computed: {
    periodDays() {
      return utils.getDays(this.period[0], this.period[1]) + 1;
    },
    periodLastMonth() {
      if (this.periodDays > 30) {
        return null;
      }
      let from = new Date(this.period[0]);
      let to = new Date(this.period[1]);
      from.setDate(from.getDate() - 30);
      to.setDate(to.getDate() - 30);
      return [from, to];
    },
    periodLastYear() {
      if (this.periodDays > 365) {
        return null;
      }
      let from = new Date(this.period[0]);
      let to = new Date(this.period[1]);
      from.setFullYear(from.getFullYear() - 1);
      to.setFullYear(to.getFullYear() - 1);
      return [from, to];
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    }
  }
};
</script>
